import { j as a } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as m } from "react";
import { clsx as u } from "../../../../node_modules/clsx/dist/clsx.m.js";
import t from "../Calender.module.scss.js";
import { getStartDate as D, getEndDate as b, getMonthsInYearArray as v } from "../calender.helper.js";
const j = ({
  selectedDates: s,
  selectedMonth: d,
  onSelect: l,
  minDate: n,
  maxDate: o,
  events: c,
  disabledDates: g
}) => {
  const p = D(s) || void 0, x = b(s) || void 0, f = v(
    d,
    p,
    x,
    n,
    o,
    g,
    c
  ), i = s.length === 1;
  return /* @__PURE__ */ a.jsx("div", { className: "flex flex-col gap-025 w-full", children: /* @__PURE__ */ a.jsx("div", { className: "grid grid-cols-3 gap-y-200 gap-x-100 w-full", children: f.map((e, r) => /* @__PURE__ */ a.jsx(
    "div",
    {
      className: u(t.cell, "!w-[88px] !h-[30px]", {
        [t.tomonth]: e.isCurrentDay,
        [t.event]: e.isEventDay,
        [t.startDate]: !i && e.isStartDate,
        [t.endDate]: !i && e.isEndDate,
        [t.inRange]: !i && e.isInRange,
        [t.selected]: e.isStartDate || e.isEndDate,
        [t.startOfWeek]: e.isStartColumn,
        [t.endOfWeek]: e.isEndColumn,
        [t.disabled]: e.disabled
      }),
      "data-testid": e.month,
      children: /* @__PURE__ */ a.jsx(
        "button",
        {
          className: "!rounded-x-small",
          tabIndex: -1,
          onClick: () => l(e.date),
          disabled: e.disabled,
          type: "button",
          children: e.month
        },
        r
      )
    },
    r
  )) }) });
}, N = m(j);
export {
  N as default
};
//# sourceMappingURL=Months.js.map
